import type { PropsWithChildren } from 'react'
import { useAuthStore } from '../store/auth-store'

export function PermissionRoute({ permission, children }: PropsWithChildren<{ permission: string }>) {
  const permissions = useAuthStore((state) => state.user?.permissions ?? [])
  if (permissions.includes('*') || permissions.includes(permission)) return children
  return <section className="page-stack">
    <div className="error-state" role="alert">
      <strong>Acesso não autorizado</strong>
      <p>Seu papel não possui a permissão necessária para abrir este módulo.</p>
      <code>Permissão exigida: {permission}</code>
    </div>
  </section>
}
